import React, { useEffect, useState } from "react";

import EmplacementTable from "./EmplacementTable";
import { DownloadOutlined } from "@mui/icons-material";
import SearchIcon from '@mui/icons-material/Search';
import { Button, Grid, TextField } from "@mui/material";

export default function EmplacementFiltre() {
  const [filtre, setFiltre] = useState({
    mot_cle: "",
    refresh: 0,
  });
  const [formOpen, setFormOpen] = useState(false);
  const [excelExport, declenceExportToExcel] = useState(0);

  const downloadExcel = () => {
    declenceExportToExcel(excelExport + 1);
  };
  const handleRefreshData = () => {
    setFormOpen(false);
    setFiltre({ ...filtre, refresh: filtre.mot_cle + 1 });
  };

  const handlechangeFiltre = (evt) => {
    const { name, value } = evt.target;
    setFiltre({ ...filtre, [name]: value });
  };

  const handleCLickNewEmplacement = () => {
    setFormOpen(!formOpen);
  };

  return (
    <Grid display={"flex"} flexDirection={"column"} height={"70vh"}>
      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <Button
          sx={{ display: "none" }}
          variant="outlined"
          onClick={handleCLickNewEmplacement}
        >
          Creer
        </Button>
        <TextField
          sx={{ width: 400 }}
          size="small"
          name="mot_cle"
          value={filtre.mot_cle}
          label="Mot clé"
          onChange={handlechangeFiltre}
          className="filtre_list"
        />
        <Button
          variant="outlined"
          className="filtre_list"
          onClick={handleRefreshData}
        >
          <SearchIcon />
        </Button>
        <Button
          variant="outlined"
          className="filtre_list"
          onClick={downloadExcel}
        >
          <DownloadOutlined /> Excel export
        </Button>
      </Grid>
      <Grid flexGrow={1} mt={3}>
        <EmplacementTable
          excelExport={excelExport}
          filtre={filtre}
          form_open={formOpen}
          refreshData={handleRefreshData}
        />
      </Grid>
    </Grid>
  );
}
